export type SurchargeType = 'OOG' | 'OOA' | 'VWC' | 'LT';

export const ToSurchargeType = (
  x: string | 'out-of-gauge' | 'remote-destination' | 'local-tax' | undefined
): SurchargeType | null => {
  switch (x?.toLowerCase()) {
    case 'out-of-gauge':
      return 'OOG';

    case 'out-of-area':
    case 'remote-destination':
      return 'OOA';

    case 'local-tax':
      return 'LT';

    default:
      return null;
  }
};

export const ToSurchargeDefaultName = (x: SurchargeType | string): string => {
  switch (x) {
    case 'OOG':
      return 'Handling Charge';

    case 'OOA':
      return 'Remote Destination Charge';

    case 'LT':
      return 'Local Tax Charge';

    default:
      return x;
  }
};
